import { useAtom } from "jotai";
import { backendDataAtom } from "atoms/backendDataAtom.js";
import { backendPost } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useUserActions() {
  const [backendData, setBackendData] = useAtom(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state =
    backendData?.type === "user-list"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "user-list",
      data: data,
    });
  };

  const createOrUpdateUser = async (form_data, setError) => {
    const to_send = { ...form_data };
    to_send.api_version = "v2";

    return await backendPost("data/user", {
      label: "Benutzer",
      toSend: to_send,
      enqueueSnackbar,
      setError,
      throwOnFailure: true,
      setResult: (res) => {
        updateListItemState(backendData, setBackendData, res);
      },
    });
  };

  const uploadUserList = async (form_data) => {
    form_data.api_version = "v2";

    await backendPost("data/benutzers/upload", {
      toSend: form_data,
      enqueueSnackbar,
      setResult: () => {
        // After upload, we need to refetch the entire list
        // This is handled by the page component
      },
    });
  };

  return {
    createOrUpdateUser,
    uploadUserList,
    setState,
    state,
  };
}
